module.exports = "<p>nuevalicitacion works!</p>\n"